import { useEffect } from 'react';

import { useCheckVerificationsComplete } from 'hooks/useCheckVerificationsComplete';
import { useGetMyProfile } from 'services/hooks/user';
import { openModal, useModalStackStore } from 'store/modalStackStore';

import RevenueShareTermsAgreementModal from 'components/modal/RevenueShareTermsAgreementModal';

/**
 * 리워드 대시보드 진입 시, 본인인증·계좌인증을 마친 기존 유저가
 * 수익분배약관에 미동의(revenueShareTermsAgreedAt == null)면 동의 모달을 1회 노출한다.
 *
 * - 대시보드 스코프 — 약관 링크로 열리는 /policy 새 탭에서 재노출되지 않도록 전역 Provider 대신 사용.
 */
export function useRevenueShareTermsGate() {
  const { data: profile } = useGetMyProfile();
  const { isFetched, isIdentityVerificationCompleted, isBankAccountVerificationCompleted } =
    useCheckVerificationsComplete();

  // 모달을 띄우는 조건과 동일. 대시보드 콘텐츠 게이팅에도 동일 조건을 그대로 사용한다.
  const needsAgreement = Boolean(
    isFetched &&
    profile &&
    isIdentityVerificationCompleted &&
    isBankAccountVerificationCompleted &&
    !profile.revenueShareTermsAgreedAt
  );

  useEffect(() => {
    if (!needsAgreement) return;

    // 모듈 헬퍼와 동일하게 getState로 최신 stack을 직접 조회 (전체 store 구독 불필요)
    const isNotOpen = !useModalStackStore.getState().checkIsModalOpenByModalName(RevenueShareTermsAgreementModal.name);

    if (isNotOpen) {
      openModal(<RevenueShareTermsAgreementModal />, {
        closeOnBackdropClick: false,
        modalWrapperStyle: { maxWidth: '320px' },
      });
    }
  }, [needsAgreement]);

  return {
    // profile/identity/bankAccount 조회 완료 여부 (확정 전까지 콘텐츠 노출 보류)
    isResolved: isFetched,
    needsAgreement,
  };
}
